<div class="button-center">
    <div class="workflow-button-label" *ngIf="!field.noLabel"></div>
    <button nz-button nzType="primary" (click)="openComponentAction($event, field.action)" [disabled]="field.isDisabled" [nzSize]="field.size == null? 'default': field.size">
        @if( field.action?.icon){
            <nz-icon [nzType]="field.action?.icon" />
        }   
        {{field.label|translateTA}}
    </button>
</div>
